import React, { useState } from 'react';
import '../../../assets/styles/HowToUse.css';
import Navbar from '../../../components/AuctionFeatureComponents/Home/Navbar';
import createAuctionImage from '../../../assets/images/howtouse/create_auction_image.png';
import auctionDetailsImage from '../../../assets/images/howtouse/create_auction_details_image.png';
import adminDashboardNavigatorImage from '../../../assets/images/howtouse/admin_dashboard_navigation.png';
import adminDashboardViewImage from '../../../assets/images/howtouse/admin_dashboard_view.png';
import addNewTeamImage from '../../../assets/images/howtouse/add_team_image.png';
import teamManagementViewImage from '../../../assets/images/howtouse/manage_teams_image.png';
import addNewPlayerImage from '../../../assets/images/howtouse/add_new_player_image.png';
import playerManagementViewImage from '../../../assets/images/howtouse/manage_player_image.png';
import obsOverlayPreviewImage from '../../../assets/images/howtouse/obs_overlay_link_image.png';
import obsOverlayOverviewImage from '../../../assets/images/howtouse/obs_overlay_overview_image.png'; 

const HowToUse = () => {
  const [selectedTopic, setSelectedTopic] = useState('introduction');

  const topics = [
    { id: 'introduction', title: 'Introduction' },
    { id: 'auction-register', title: 'Auction Registration' },
    { id: 'team-player-management', title: 'Team-Player Management' },
    { id: 'screens-overlays', title: 'Screen and Overlay Themes' }
  ];

  const getContent = (topicId) => {
    switch (topicId) {
      case 'introduction':
        return {
          title: 'Introduction to Live Auction',
          content: (
            <div>
              <p>
                Welcome to our comprehensive guide on Live auctions! This platform is designed to 
                streamline the process of organizing and participating in player auctions across various sports 
                including cricket, football, basketball, and volleyball.
              </p>
              <p>
                Our system provides a seamless experience for auction organizers, team owners, and spectators 
                alike. Whether you're new to player auctions or an experienced user, this guide will help you 
                navigate all the features and functionalities of our platform.
              </p>
              <h3>Key Features</h3>
              <ul>
                <li>Real-time bidding system</li>
                <li>Mobile-responsive design</li>
                <li>Live streaming integration</li>
                <li>Comprehensive analytics and reporting</li>
                <li>Customizable auction rules and formats</li>
                <li>Secure authentication and data protection</li>
              </ul>
              <h3>Who Can Benefit</h3>
              <p>
                Our platform is ideal for league organizers, team owners, managers, and sports enthusiasts who 
                want to experience the excitement of player auctions in a digital environment. The intuitive 
                interface ensures that users of all technical levels can participate effectively.
              </p>
            </div>
          )
        };
      case 'auction-register':
        return {
          title: 'Auction Registration',
          content: (
            <div>
              <p>
                Registering for an auction is the first step to participate in the player selection process. 
                Follow these steps to successfully register for an auction:
              </p>
              <h3>For Auction Organizers</h3>
              <ol>
                {/* Step 1: Go to admin dashboard */}
                <li>Navigate to admin dashboard</li>
                <div className="image-container mt-4 mb-4 text-center">
                <p className="image-caption">
                  <em>"Admin Dashboard" button highlighted</em>
                </p>
                <img 
                  src={adminDashboardNavigatorImage} 
                  alt="Dashboard with Create Auction button" 
                  className="img-fluid how-to-use-image"
                />
              </div>

              {/* Step 2: Navigate to the "Create Auction" section */}
                <li>Navigate to the "Create Auction" section from your dashboard</li>
                <div className="image-container mt-4 mb-4 text-center">
                <p className="image-caption">
                  <em>Dashboard with "Create Auction" button highlighted</em>
                </p>
                <img 
                  src={createAuctionImage} 
                  alt="Dashboard with Create Auction button" 
                  className="img-fluid how-to-use-image"
                />
              </div>

                <li>Fill in the auction details including sport, date, and team information</li>
                <div className="image-container mt-4 mb-4 text-center">
                <p className="image-caption">
                  <em>Create Auction Form</em>
                </p>
                <img 
                  src={auctionDetailsImage} 
                  alt="Dashboard with Create Auction button" 
                  className="img-fluid how-to-use-image"
                />
                </div>
                  <li>Once Auction is created, you are redirected to the admin dashboard</li>
                  <div className="image-container mt-4 mb-4 text-center">
                  <p className="image-caption">
                    <em>Auction Overview on Admin Dashboard</em>
                  </p>
                  <img 
                    src={adminDashboardViewImage} 
                    alt="Dashboard with Create Auction button" 
                    className="img-fluid how-to-use-image"
                  />
                </div>   
              </ol>
              
            </div>
          )
        };

        case 'team-player-management':
        return {
          title: 'Team-Player Management',
          content: (
            <div>
              <p>
                Adding team owners and players to get ready for the auction. 
                Follow these steps to successfully manage teams and players for an auction:
              </p>
              <h3>For Auction Organizers</h3>
              <ol>
                {/* Step 1: Go to admin dashboard */}
                <li>Navigate to admin dashboard to specific auction</li>
                <div className="image-container mt-4 mb-4 text-center">
                <p className="image-caption">
                  <em>Dashboard with all existing auctions</em>
                </p>
                <img 
                  src={adminDashboardNavigatorImage} 
                  alt="Dashboard with Create Auction button" 
                  className="img-fluid how-to-use-image"
                />
              </div>

              {/* Step 2: Click on add team button*/}
                <li>Navigate and click on to the "Add Team" button from your dashboard</li>
                <div className="image-container mt-4 mb-4 text-center">
                <p className="image-caption">
                  <em>Dashboard with "Add Team" button highlighted</em>
                </p>
                <img 
                  src={teamManagementViewImage} 
                  alt="Dashboard with Create Auction button" 
                  className="img-fluid how-to-use-image"
                />
              </div>

                <li>Fill in the team details including owner name, budget, and other information</li>
                <div className="image-container mt-4 mb-4 text-center">
                <p className="image-caption">
                  <em>Create Team Form</em>
                </p>
                <img 
                  src={addNewTeamImage} 
                  alt="Dashboard with Create Auction button" 
                  className="img-fluid how-to-use-image"
                />
                </div>
                  <li>Navigate and click on to the "Add Player" button from your dashboard</li>
                  <div className="image-container mt-4 mb-4 text-center">
                  <p className="image-caption">
                    <em>Dashboard with "Add Player" button highlighted</em>
                  </p>
                  <img 
                    src={playerManagementViewImage} 
                    alt="Dashboard with Create Auction button" 
                    className="img-fluid how-to-use-image"
                  />
                </div>

                <li>Fill in the player details including  name, stats, profile picture, and other information</li>
                <div className="image-container mt-4 mb-4 text-center">
                <p className="image-caption">
                  <em>Create Team Form</em>
                </p>
                <img 
                  src={addNewPlayerImage} 
                  alt="Dashboard with Create Auction button" 
                  className="img-fluid how-to-use-image"
                />
                </div>   
              </ol>
              
            </div>
          )
        };

      case 'screens-overlays':
        return {
          title: 'Screen and Overlay Themes',
          content: (
              <div>
              <p>
                Live Auction platform offers customizable screen and overlay themes to enhance the visual experience 
                for both participants and spectators during live auctions.
              </p>
              <h3>For Auction Organizers</h3>
              <ol>
                {/* Step 1: Go to admin dashboard */}
                <li>Navigate to admin dashboard to see obs overlay templates</li>
                <div className="image-container mt-4 mb-4 text-center">
                <p className="image-caption">
                  <em>Dashboard with "Preview" button highlighted</em>
                </p>
                <img 
                  src={obsOverlayPreviewImage} 
                  alt="Dashboard with Create Auction button" 
                  className="img-fluid how-to-use-image"
                />
              </div>

              <li>Click on preview to redirect to obs overlay screen play</li>
                <div className="image-container mt-4 mb-4 text-center">
                <p className="image-caption">
                  <em>Overlay screen can be attached with OBS for multiple stream setup</em>
                </p>
                <img 
                  src={obsOverlayOverviewImage} 
                  alt="Dashboard with Create Auction button" 
                  className="img-fluid how-to-use-image"
                />
              </div>
              </ol>
              </div>
          )
        };
      default:
        return {
          title: 'Introduction to Sports Player Auctions',
          content: (
            <div>
              <p>
                Welcome to our comprehensive guide on sports player auctions! This platform is designed to 
                streamline the process of organizing and participating in player auctions across various sports 
                including cricket, football, basketball, and volleyball.
              </p>
            </div>
          )
        };
    }
  };

  const { title, content } = getContent(selectedTopic);

  return (
    <>
      <Navbar />
      <div className="container-fluid mt-5 pt-5">
        <div className="row">
          <div className="col-md-3">
            <div className="how-to-use-sidebar">
              <h3 className="sidebar-title">How to Use</h3>
              <ul className="topic-list">
                {topics.map((topic) => (
                  <li 
                    key={topic.id} 
                    className={`topic-item ${selectedTopic === topic.id ? 'active' : ''}`}
                    onClick={() => setSelectedTopic(topic.id)}
                  >
                    {topic.title}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-md-9">
            <div className="how-to-use-content">
              <h1>{title}</h1>
              {content}
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="bg-dark text-white text-center py-3 mt-5">
        <p>© 2025 LiveAuction. All rights reserved.</p>
        <div className="footer-links">
          <a href="/privacy-policy">Privacy Policy</a> | 
          <a href="/terms-of-service"> Terms of Service</a> |
          <a href="/contact"> Contact Us</a>
        </div>
      </footer>
    </>
  );
};

export default HowToUse;